import { render, staticRenderFns } from "./userInformation.vue?vue&type=template&id=d981f46c&scoped=true"
import script from "./userInformation.vue?vue&type=script&lang=js"
export * from "./userInformation.vue?vue&type=script&lang=js"
import style0 from "./userInformation.vue?vue&type=style&index=0&id=d981f46c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d981f46c",
  null
  
)

export default component.exports